<template>
  <v-container class="formulario-wrapper" fluid>
    <v-card class="elevation-2 rounded-lg">

      <!-- BOTÕES DE AÇÃO NO TOPO -->
      <v-card-actions class="linhabuton pa-4 ">
        <v-row align="center">
          <v-col cols="4" class="text-left">
            <v-btn color="error" outlined @click="dialogExcluir = true" v-if="formData.id && formData.atendido != 1">
              Excluir
            </v-btn>
          </v-col>
          
          <v-col cols="4" class="text-center"> 
            <v-btn text @click="cancelar" outlined>
              {{ formData.atendido == 1 ? 'Voltar' : 'Cancelar' }}
            </v-btn>
          </v-col>

          <v-col cols="4" class="text-right">
            <v-btn color="primary" @click="salvar" :loading="salvando" :disabled="formData.atendido == 1" v-if="formData.atendido != 1">
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

      <v-divider class="divisor-secao"></v-divider>

      <!-- AVISO DE TRANSMITIDO / SOMENTE LEITURA -->
      <div v-if="formData.atendido == 1" class="px-4 pt-4">
        <v-alert
          type="info"
          dense
          outlined
          class="mb-0 font-weight-medium"
        >
          <v-icon left color="info">mdi-lock</v-icon>
          Este pré-cadastro já foi transmitido ao servidor e está em modo somente leitura (não permite alterações).
        </v-alert>
      </div>

      <!-- FORMULÁRIO DE PRÉ-CADASTRO DE CLIENTE -->
      <v-card-text class="pa-4 pa-sm-6">
        <v-form ref="form" v-model="formValido" :disabled="formData.atendido == 1">
          
          <!-- SEÇÃO 1: CLIENTE -->
          <div class="d-flex align-center mt-3 mb-4">
            <v-icon small color="primary" class="mr-2">mdi-account-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CLIENTE
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="6" sm="6" md="4">
              <v-select
                v-model="formData.clltipopessoa"
                :items="tiposPessoa"
                item-text="text"
                item-value="value"
                label="Tipo Pessoa *"
                outlined
                dense
                hide-details="auto"
                class="mb-3"
              ></v-select>
            </v-col>

            <v-col cols="6" class="text-right">
              <v-btn color="primary" @click="importar" :loading="importando">
                Importar
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.cllnome"
                :label="formData.clltipopessoa === 'J' ? 'Nome / Razão Social *' : 'Nome Completo *'"
                outlined dense hide-details="auto"
                required
                class="mb-3"
                :rules="[v => !!v || 'Campo obrigatório']"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.cllnomefantasia"
                label="Nome Fantasia"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                v-model="formData.cllcnpjCpf"
                :label="formData.clltipopessoa === 'J' ? 'CNPJ' : 'CPF'"
                outlined dense hide-details="auto"
                class="mb-3"
                :maxlength="formData.clltipopessoa === 'J' ? 18 : 14"
                @keydown="bloquearNaoNumericos"
                @input="formatarCpfCnpj"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                v-model="formData.cllrgInscricao"
                :label="formData.clltipopessoa === 'J' ? 'Inscrição Estadual' : 'RG'"
                outlined dense hide-details="auto"
                class="mb-3"
                :maxlength="formData.clltipopessoa === 'J' ? 18 : 12"
                @keydown="bloquearNaoNumericos"
                @input="formatarRgInscricao"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                v-model="formData.clldataNascimentoAbertura"
                :label="formData.clltipopessoa === 'J' ? 'Data de Abertura' : 'Data de Aniversário'"
                type="date"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SEÇÃO 2: ENDEREÇO -->
          <div class="d-flex align-center mt-5 mb-4">
            <v-icon small color="primary" class="mr-2">mdi-map-marker-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              ENDEREÇO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>

          <v-row dense>
            <v-col cols="4" sm="4" md="3">
              <v-text-field
                v-model="formData.cllcep"
                label="CEP"
                outlined dense hide-details="auto"
                class="mb-3"
                maxlength="9"
                @keydown="bloquearNaoNumericos"
                @input="formatarCep"
                @blur="buscarCep"
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="8" md="6">
              <v-text-field
                v-model="formData.cllendereco"
                label="Endereço / Logradouro"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4" md="3">
              <v-text-field
                v-model="formData.cllnumero"
                label="Número"
                outlined dense hide-details="auto"
                class="mb-3"
                @keydown="bloquearNaoNumericos"
                @input="apenasNumeros('cllnumero')"
              ></v-text-field>
            </v-col>

            <v-col cols="8" sm="8" md="4">
              <v-text-field
                v-model="formData.cllcomplemento"
                label="Complemento"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="4">
              <v-text-field
                v-model="formData.cllbairro"
                label="Bairro"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4" md="3">
              <v-text-field
                v-model="formData.cllcidade"
                label="Cidade"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-text-field>
            </v-col>

            <v-col cols="2" sm="2" md="1">
              <v-select
                v-model="formData.clluf"
                :items="ufs"
                label="UF"
                outlined dense hide-details="auto"
                class="mb-3"
              ></v-select>
            </v-col>
          </v-row>

          <!-- SEÇÃO 3: CONTATO E COMUNICAÇÃO -->
          <div class="d-flex align-center mt-5 mb-4">
            <v-icon small color="primary" class="mr-2">mdi-phone-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CONTATO & COMUNICAÇÃO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>

          <v-row dense>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="formData.clltelefone"
                label="Telefone"
                outlined dense hide-details="auto"
                class="mb-3"
                maxlength="14"
                prepend-inner-icon="mdi-phone"
                @keydown="bloquearNaoNumericos"
                @input="formatarTelefone"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4">
              <v-text-field
                v-model="formData.cllcelular"
                label="Celular"
                outlined dense hide-details="auto"
                class="mb-3"
                maxlength="15"
                prepend-inner-icon="mdi-cellphone"
                @keydown="bloquearNaoNumericos"
                @input="formatarCelular"
              ></v-text-field>
            </v-col>

            <v-col cols="4" sm="4">
              <v-text-field
                v-model="formData.cllcontato"
                label="Pessoa de Contato"
                outlined dense hide-details="auto"
                class="mb-3"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>

            <v-col cols="6" sm="6">
              <v-text-field
                v-model="formData.cllemailNfe"
                label="E-mail NF-e"
                type="email"
                outlined dense hide-details="auto"
                class="mb-3"
                prepend-inner-icon="mdi-file-document"
              ></v-text-field>
            </v-col>

            <v-col cols="6" sm="6">
              <v-text-field
                v-model="formData.cllemailFinanceiro"
                label="E-mail Financeiro"
                type="email"
                outlined dense hide-details="auto"
                class="mb-3"
                prepend-inner-icon="mdi-cash-email"
              ></v-text-field>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>
    </v-card>

    <!-- DIÁLOGO DE CONFIRMAÇÃO DE EXCLUSÃO -->
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title class="headline error white--text">Confirmar Exclusão</v-card-title>
        <v-card-text class="pt-4 black--text">
          Deseja realmente excluir este Pré-Cadastro de Cliente?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn color="error" text @click="confirmarExcluir">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIÁLOGO DE CONFIRMAÇÃO DE CANCELAMENTO -->
    <v-dialog v-model="dialogCancelar" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text">Confirmar Saída</v-card-title>
        <v-card-text class="pt-4 black--text">
          Existem dados preenchidos no formulário. Deseja realmente sair sem salvar as alterações?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCancelar = false">Continuar Editando</v-btn>
          <v-btn color="primary" text @click="confirmarCancelar">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIÁLOGO DE AVISO DA IMPORTAÇÃO -->
    <v-dialog v-model="dialogAvisoImportacao" max-width="400">
      <v-card class="rounded-lg">
        <v-card-title class="headline primary white--text d-flex align-center pa-4">
          <v-icon color="white" class="mr-2">mdi-alert-circle-outline</v-icon>
          Atenção
        </v-card-title>
        <v-card-text class="pt-4 pb-2 black--text text-body-1">
          A importação de dados por CNPJ é apenas para Pessoa Jurídica.
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAvisoImportacao = false">Entendi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR DE NOTIFICAÇÕES -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import moment from 'moment';

export default {
  name: 'ViewPrecadastroCliente',

  data() {
    return {
      formValido: true,
      salvando: false,
      importando: false,
      dialogExcluir: false,
      dialogCancelar: false,
      dialogAvisoImportacao: false,
      permitirNavegacao: false,
      proximaRota: null,
      
      formData: {
        id: null,
        cllidclienteprecadastro: null,
        clltipopessoa: 'F',
        cllnome: '',
        cllnomefantasia: '',
        cllcnpjCpf: '',
        cllrgInscricao: '',
        clldataNascimentoAbertura: '',
        cllcep: '',
        cllendereco: '',
        cllnumero: '',
        cllcomplemento: '',
        cllbairro: '',
        cllcidade: '',
        clluf: '',
        clltelefone: '',
        cllcelular: '',
        cllcontato: '',
        cllemail: '',
        cllemailNfe: '',
        cllemailFinanceiro: '',
        clldatadigitacao: null,
        cllidvendedor: null,
      },

      tiposPessoa: [
        { text: 'Pessoa Física', value: 'F' },
        { text: 'Pessoa Jurídica', value: 'J' },
      ],

      ufs: [
        'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 
        'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 
        'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
      ],

      snackbar: {
        show: false,
        text: '',
        color: 'success',
      },
    };
  },

  watch: {
    'formData.clltipopessoa'() {
      this.formatarCpfCnpj();
      this.formatarRgInscricao();
    },
  },

  computed: {
    isOrigemPedido() {
      return this.$route.query.origem === 'pedido';
    },
  },

  methods: {
    getTabelaLeads() {
      return db.clientelead;
    },

    mostrarMensagem(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    bloquearNaoNumericos(e) {
      const permitidas = [
        'Backspace', 'Tab', 'Enter', 'Delete', 'Escape', 
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 
        'Home', 'End'
      ];
      if (permitidas.includes(e.key) || e.ctrlKey || e.metaKey || e.altKey) {
        return;
      }
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },

    apenasNumeros(campo) {
      this.$nextTick(() => {
        if (this.formData[campo] !== undefined && this.formData[campo] !== null) {
          this.formData[campo] = String(this.formData[campo]).replace(/\D/g, '');
        }
      });
    },

    formatarRgInscricao() {
      this.$nextTick(() => {
        if (!this.formData.cllrgInscricao) return;
        const nums = String(this.formData.cllrgInscricao).replace(/\D/g, '');

        if (this.formData.clltipopessoa === 'F') {
          // RG (Pessoa Física): 00.000.000-0 (máx 9 dígitos)
          const limpo = nums.slice(0, 9);
          if (limpo.length <= 2) {
            this.formData.cllrgInscricao = limpo;
          } else if (limpo.length <= 5) {
            this.formData.cllrgInscricao = `${limpo.slice(0, 2)}.${limpo.slice(2)}`;
          } else if (limpo.length <= 8) {
            this.formData.cllrgInscricao = `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5)}`;
          } else {
            this.formData.cllrgInscricao = `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}-${limpo.slice(8)}`;
          }
        } else {
          // Inscrição Estadual (Pessoa Jurídica): 000.000.000.000 (máx 12-14 dígitos)
          const limpo = nums.slice(0, 14);
          if (limpo.length <= 3) {
            this.formData.cllrgInscricao = limpo;
          } else if (limpo.length <= 6) {
            this.formData.cllrgInscricao = `${limpo.slice(0, 3)}.${limpo.slice(3)}`;
          } else if (limpo.length <= 9) {
            this.formData.cllrgInscricao = `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6)}`;
          } else if (limpo.length <= 12) {
            this.formData.cllrgInscricao = `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6, 9)}.${limpo.slice(9)}`;
          } else {
            this.formData.cllrgInscricao = `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6, 9)}.${limpo.slice(9, 12)}-${limpo.slice(12)}`;
          }
        }
      });
    },

    formatarCpfCnpj() {
      this.$nextTick(() => {
        if (!this.formData.cllcnpjCpf) return;
        const nums = String(this.formData.cllcnpjCpf).replace(/\D/g, '');
        
        if (this.formData.clltipopessoa === 'F') {
          const limpo = nums.slice(0, 11);
          if (limpo.length <= 3) {
            this.formData.cllcnpjCpf = limpo;
          } else if (limpo.length <= 6) {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 3)}.${limpo.slice(3)}`;
          } else if (limpo.length <= 9) {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6)}`;
          } else {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6, 9)}-${limpo.slice(9)}`;
          }
        } else {
          const limpo = nums.slice(0, 14);
          if (limpo.length <= 2) {
            this.formData.cllcnpjCpf = limpo;
          } else if (limpo.length <= 5) {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 2)}.${limpo.slice(2)}`;
          } else if (limpo.length <= 8) {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5)}`;
          } else if (limpo.length <= 12) {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}/${limpo.slice(8)}`;
          } else {
            this.formData.cllcnpjCpf = `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}/${limpo.slice(8, 12)}-${limpo.slice(12)}`;
          }
        }
      });
    },

    formatarTelefone() {
      if (!this.formData.clltelefone) return;
      const nums = this.formData.clltelefone.replace(/\D/g, '').slice(0, 10);
      if (nums.length <= 2) {
        this.formData.clltelefone = nums ? `(${nums}` : '';
      } else if (nums.length <= 6) {
        this.formData.clltelefone = `(${nums.slice(0, 2)}) ${nums.slice(2)}`;
      } else {
        this.formData.clltelefone = `(${nums.slice(0, 2)}) ${nums.slice(2, 6)}-${nums.slice(6)}`;
      }
    },

    formatarCelular() {
      if (!this.formData.cllcelular) return;
      const nums = this.formData.cllcelular.replace(/\D/g, '').slice(0, 11);
      if (nums.length <= 2) {
        this.formData.cllcelular = nums ? `(${nums}` : '';
      } else if (nums.length <= 7) {
        this.formData.cllcelular = `(${nums.slice(0, 2)}) ${nums.slice(2)}`;
      } else {
        this.formData.cllcelular = `(${nums.slice(0, 2)}) ${nums.slice(2, 7)}-${nums.slice(7)}`;
      }
    },

    formatarCep() {
      if (!this.formData.cllcep) return;
      const nums = this.formData.cllcep.replace(/\D/g, '').slice(0, 8);
      if (nums.length <= 5) {
        this.formData.cllcep = nums;
      } else {
        this.formData.cllcep = `${nums.slice(0, 5)}-${nums.slice(5)}`;
      }
    },

    async buscarCep() {
      const cepLimpo = this.formData.cllcep ? this.formData.cllcep.replace(/\D/g, '') : '';
      if (cepLimpo.length !== 8) return;
      
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();
        if (!data.erro) {
          if (data.logradouro) this.formData.cllendereco = data.logradouro;
          if (data.bairro) this.formData.cllbairro = data.bairro;
          if (data.localidade) this.formData.cllcidade = data.localidade;
          if (data.uf) this.formData.clluf = data.uf;
        }
      } catch (e) {
        console.error('Erro ao buscar CEP:', e);
      }
    },

    async carregarPrecadastro() {
      const idQuery = this.$route.query.id || this.$route.query.clienteCodigo;
      if (!idQuery) return;

      try {
        const tabelaLeads = this.getTabelaLeads();
        let item = null;
        if (tabelaLeads) {
          item = await tabelaLeads.get(Number(idQuery));
        }

        if (item) {
          this.formData = { ...this.formData, ...item };
        } else {
          // Se não encontrou no pré-cadastro, tenta no cliente
          const cli = await db.cliente.get(Number(idQuery));
          if (cli) {
            this.formData.cllnome = cli.nome || '';
            this.formData.cllnomefantasia = cli.nomefantasia || '';
            this.formData.cllcidade = cli.cidade || '';
            this.formData.cllcnpjCpf = cli.cnpjCpf || cli.cnpj_cpf || '';
          }
        }
      } catch (e) {
        console.error('Erro ao carregar pré-cadastro:', e);
      }
    },

    async salvar() {
      if (this.formData.atendido == 1) {
        this.mostrarMensagem('Este pré-cadastro já foi transmitido ao servidor e não pode ser alterado.', 'primary');
        return;
      }

      if (!this.formData.cllnome || !this.formData.cllnome.trim()) {
        this.mostrarMensagem('Preencha o Nome/Razão Social do cliente', 'primary');
        return;
      }

      this.salvando = true;

      try {
        const tabelaLeads = this.getTabelaLeads();
        if (!tabelaLeads) {
          throw new Error('Tabela de pré-cadastro não encontrada no banco local.');
        }

        const param = await db.parametro.toCollection().first();
        const cllidvendedor = param ? param.idvendedorlogado : null;

        const agoraLocal = moment().format('YYYY-MM-DDTHH:mm:ss');

        const payload = {
          ...this.formData,
          cllidvendedor,
          clldatadigitacao: this.formData.clldatadigitacao || agoraLocal,
        };

        if (this.formData.id) {
          await tabelaLeads.put(payload);
        } else {
          delete payload.id;
          const newId = await tabelaLeads.add(payload);
          this.formData.id = newId;
        }

        this.mostrarMensagem('Pré-Cadastro de Cliente salvo com sucesso!', 'success');
        this.permitirNavegacao = true;
        setTimeout(() => {
          this.voltarParaLista();
        }, 1000);
      } catch (error) {
        console.error('Erro ao salvar pré-cadastro:', error);
        this.mostrarMensagem(error.message || 'Erro ao salvar o pré-cadastro.', 'error');
      } finally {
        this.salvando = false;
      }
    },

    async confirmarExcluir() {
      if (!this.formData.id) return;
      if (this.formData.atendido == 1) {
        this.mostrarMensagem('Este pré-cadastro já foi transmitido ao servidor e não pode ser excluído.', 'primary');
        return;
      }
      try {
        const tabelaLeads = this.getTabelaLeads();
        if (tabelaLeads) {
          await tabelaLeads.delete(this.formData.id);
        }
        this.dialogExcluir = false;
        this.permitirNavegacao = true;
        this.mostrarMensagem('Pré-Cadastro excluído com sucesso!', 'info');
        setTimeout(() => {
          this.voltarParaLista();
        }, 1000);
      } catch (e) {
        console.error('Erro ao excluir pré-cadastro:', e);
        this.mostrarMensagem('Erro ao excluir pré-cadastro', 'error');
      }
    },

    async importar() {
      const cnpjLimpo = (this.formData.cllcnpjCpf || '').replace(/\D/g, '');

      if (this.formData.clltipopessoa !== 'J') {
        this.dialogAvisoImportacao = true;
        return;
      }

      if (cnpjLimpo.length !== 14) {
        this.mostrarMensagem('Informe um CNPJ válido com 14 dígitos para importar.', 'primary');
        return;
      }

      this.importando = true;

      try {
        let sucesso = false;

        // Tenta primeiro via CNPJ.ws (pois traz a Inscrição Estadual)
        try {
          const resCnpjWs = await fetch(`https://publica.cnpj.ws/cnpj/${cnpjLimpo}`);
          if (resCnpjWs.ok) {
            const data = await resCnpjWs.json();
            const est = data.estabelecimento || {};

            if (data.razao_social) this.formData.cllnome = data.razao_social;
            if (est.nome_fantasia) this.formData.cllnomefantasia = est.nome_fantasia;
            
            // Captura da Inscrição Estadual
            if (est.inscricoes_estaduais && est.inscricoes_estaduais.length > 0) {
              const ieAtiva = est.inscricoes_estaduais.find(i => i.ativo) || est.inscricoes_estaduais[0];
              if (ieAtiva && ieAtiva.inscricao_estadual) {
                this.formData.cllrgInscricao = ieAtiva.inscricao_estadual;
                this.formatarRgInscricao();
              }
            }

            if (est.cep) {
              const cepStr = String(est.cep).replace(/\D/g, '').padStart(8, '0');
              this.formData.cllcep = `${cepStr.slice(0, 5)}-${cepStr.slice(5)}`;
            }

            const tipoLog = est.tipo_logradouro ? `${est.tipo_logradouro} ` : '';
            if (est.logradouro) this.formData.cllendereco = `${tipoLog}${est.logradouro}`;
            if (est.numero) this.formData.cllnumero = est.numero;
            if (est.complemento) this.formData.cllcomplemento = est.complemento;
            if (est.bairro) this.formData.cllbairro = est.bairro;
            if (est.cidade && est.cidade.nome) this.formData.cllcidade = est.cidade.nome;
            if (est.estado && est.estado.sigla) this.formData.clluf = est.estado.sigla.toUpperCase();

            if (est.ddd1 && est.telefone1) {
              this.formData.clltelefone = `${est.ddd1}${est.telefone1}`;
              this.formatarTelefone();
            }

            if (est.data_inicio_atividade) {
              this.formData.clldataNascimentoAbertura = this.formatarDataIso(est.data_inicio_atividade);
            }

            if (est.email) {
              this.formData.cllemail = est.email;
              this.formData.cllemailNfe = est.email;
            }

            sucesso = true;
          }
        } catch (eWs) {
          console.warn('Falha na consulta via CNPJ.ws, tentando BrasilAPI fallback...', eWs);
        }

        // Se CNPJ.ws não respondeu ou deu erro de quota, faz o fallback para a BrasilAPI
        if (!sucesso) {
          const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`);

          if (!response.ok) {
            if (response.status === 404) {
              throw new Error('CNPJ não encontrado na base de dados.');
            }
            throw new Error(`Erro ao consultar CNPJ (Status ${response.status}).`);
          }

          const data = await response.json();

          if (data.razao_social) this.formData.cllnome = data.razao_social;
          if (data.nome_fantasia) this.formData.cllnomefantasia = data.nome_fantasia;
          
          if (data.cep) {
            const cepStr = String(data.cep).replace(/\D/g, '').padStart(8, '0');
            this.formData.cllcep = `${cepStr.slice(0, 5)}-${cepStr.slice(5)}`;
          }

          if (data.logradouro) this.formData.cllendereco = data.logradouro;
          if (data.numero) this.formData.cllnumero = data.numero;
          if (data.complemento) this.formData.cllcomplemento = data.complemento;
          if (data.bairro) this.formData.cllbairro = data.bairro;
          if (data.municipio) this.formData.cllcidade = data.municipio;
          if (data.uf) this.formData.clluf = data.uf.toUpperCase();

          if (data.ddd_telefone_1) {
            this.formData.clltelefone = data.ddd_telefone_1;
            this.formatarTelefone();
          }

          if (data.data_inicio_atividade) {
            this.formData.clldataNascimentoAbertura = this.formatarDataIso(data.data_inicio_atividade);
          }

          if (data.email) {
            this.formData.cllemail = data.email;
            this.formData.cllemailNfe = data.email;
          }
        }

        this.mostrarMensagem('Dados do CNPJ importados com sucesso!', 'success');
      } catch (error) {
        console.error('Erro na importação do CNPJ:', error);
        this.mostrarMensagem(error.message || 'Falha ao buscar dados do CNPJ.', 'error');
      } finally {
        this.importando = false;
      }
    },

    formatarDataIso(dataStr) {
      if (!dataStr) return '';
      if (/^\d{4}-\d{2}-\d{2}$/.test(dataStr)) {
        return dataStr;
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataStr)) {
        const [d, m, y] = dataStr.split('/');
        return `${y}-${m}-${d}`;
      }
      try {
        const d = new Date(dataStr);
        if (!isNaN(d.getTime())) {
          return d.toISOString().split('T')[0];
        }
      } catch (e) {
        // ignora
      }
      return '';
    },

    temCamposPreenchidos() {
      if (this.formData.id) return true;
      const camposIgnorados = ['id', 'cllidclienteprecadastro', 'clltipopessoa', 'clldatadigitacao', 'cllidvendedor'];
      return Object.keys(this.formData).some(key => {
        if (camposIgnorados.includes(key)) return false;
        const valor = this.formData[key];
        return valor !== null && valor !== undefined && String(valor).trim() !== '';
      });
    },

    voltarParaLista() {
      this.permitirNavegacao = true;
      const query = {};
      if (this.isOrigemPedido) {
        query.origem = 'pedido';
      }
      this.$router.push({ path: '/listaprecadastro', query }).catch(() => {});
    },

    cancelar() {
      if (this.temCamposPreenchidos()) {
        this.dialogCancelar = true;
      } else {
        this.confirmarCancelar();
      }
    },

    confirmarCancelar() {
      this.dialogCancelar = false;
      this.permitirNavegacao = true;
      if (this.proximaRota) {
        this.$router.push(this.proximaRota).catch(() => {});
      } else {
        this.voltarParaLista();
      }
    },
  },

  created() {
    this.carregarPrecadastro();
    this.$root.$on('appbar-precadastro-voltar', this.cancelar);
  },

  beforeDestroy() {
    this.$root.$off('appbar-precadastro-voltar', this.cancelar);
  },

  beforeRouteLeave(to, from, next) {
    if (this.temCamposPreenchidos() && !this.permitirNavegacao) {
      this.dialogCancelar = true;
      this.proximaRota = to;
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 32px 16px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.linhabuton {
  border-bottom: 1px solid #e0e0e0;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}
</style>